import { gql } from '@apollo/client';

export const PeerReviewQuery = gql`
  query reviewHistory($clientId: Number!) {
    reviewHistoryPeriod(clientId: $clientId)
      @rest(type: "ReviewHistoryPeriod", path: "review.json/client/:clientId") {
      notes
      status
      hideDate
      submitterId
      fromMonth
      toMonth
      submittedAt
    }
  }
`;
